import {Component, Input, OnInit} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-meta-data',
  templateUrl: './edit-meta-data.component.html',
  styleUrls: ['./edit-meta-data.component.scss']
})
export class EditMetaDataComponent implements OnInit {
  @Input() metaDataInfo: any;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  maxLength = 350;

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.metaDataInfo.detail.push({title: value});
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }

  remove(fruit: any): void {
    const index = this.metaDataInfo.detail.indexOf(fruit);

    if (index >= 0) {
      this.metaDataInfo.detail.splice(index, 1);
    }
  }

  validateEmptyFields(): any {
    if (!this.metaDataInfo.name ||
      !this.metaDataInfo.description ||
      this.metaDataInfo.detail.length < 1
    ) {
      return false;
    } else {
      return true;
    }
  }

  sendData(): any {
    const arrToSend = [];
    this.metaDataInfo.detail.forEach(x => {
      arrToSend.push({name: x.title, id: Math.floor(Math.random() * 10)});
    });
    const dataToSend = {
      id: this.metaDataInfo.id,
      name: this.metaDataInfo.name,
      description: this.metaDataInfo.description,
      seoDetail: arrToSend
    };
    this.activeModal.close(dataToSend);
  }
}
